import get from 'lodash.get';
import React from 'react';

export const getMeasureTitleByKey = (measures, key) =>
    get(
        measures.find(measure => measure.key === key),
        'title',
        '',
    );

export const getMeasureNameByKey = (measures, key) =>
    get(
        measures.find(measure => measure.key === key),
        'name',
        '',
    );

export const getMeasureDisplayNameByKey = (measures, key) =>
    get(
        measures.find(measure => measure.key === key),
        'displayName',
        '',
    );

const getMeasureNamesByKey = (allMeasures, measure) => ({
    name: getMeasureNameByKey(allMeasures, measure),
    displayName: getMeasureDisplayNameByKey(allMeasures, measure),
});

export const getDetailedMeasureName = (allMeasures, measure) => {
    const { name, displayName } = getMeasureNamesByKey(allMeasures, measure);
    return `${displayName} (${name})`;
};

export const getDetailedMeasureNameTwoLines = (allMeasures, measure) => {
    const { name, displayName } = getMeasureNamesByKey(allMeasures, measure);
    return (
        <>
            {displayName}
            <span> ({name})</span>
        </>
    );
};
